type Counts = { pendingApprovalCount: number; notSubmittedCount: number };
export function analysisCoverageComparison(singleDay: boolean, current: Counts | null, previous: Counts | null) {
  if (!singleDay) return "multi-day" as const;
  if (!current || !previous) return "unknown" as const;
  return current.pendingApprovalCount || current.notSubmittedCount || previous.pendingApprovalCount || previous.notSubmittedCount
    ? "incomplete" as const : "complete" as const;
}
